import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { SECTION_TYPES } from 'utils/constants';
import { getDocumentFields } from 'utils/helper';
import { ContactForm } from '../ServicesContactForm';

const Intro = dynamic(() => import('UI/sections/CaseStudiesIntro'));
const PhotoGallery = dynamic(() => import('components/Common/PhotoGallery'));
const CaseProcess = dynamic(() => import('UI/sections/CaseProcess'));
const TabsSection = dynamic(() => import('UI/sections/TabsSection'));
const ReviewsSection = dynamic(() => import('UI/sections/ReviewsSection'));
const CaseParallax = dynamic(() => import('UI/sections/CaseParallax'));
const CardsSection = dynamic(() => import('UI/sections/CardsSection'));
const Images = dynamic(() => import('UI/sections/ImagesSection'));
const ProcessSection = dynamic(() => import('UI/sections/ProcessSection'));
const SvgListSection = dynamic(() => import('UI/sections/SvgListSection'));
const NewPersonIntro = dynamic(() => import('UI/sections/NewPersonIntro'));
const PlainTextSection = dynamic(() => import('UI/sections/PlainTextSection'));
const YoutubeVideosSection = dynamic(() => import('UI/sections/YoutubeVideosSection'));

const Blog = dynamic(() => import('UI/sections/Blog'));
const CardsSlider = dynamic(() => import('UI/sections/CardsSlider'));
const SvgList = dynamic(() => import('UI/sections/SvgList'));
const Card = dynamic(() => import('UI/sections/Card'));
const Works = dynamic(() => import('components/HomeCommon/Works'));
const PageIntroSection = dynamic(() => import('UI/sections/PageIntroSection'));
const FaqSection = dynamic(() => import('UI/sections/FaqSection'));
const AssessmentSection = dynamic(() => import('UI/sections/AssessmentSection'));

const SectionSelector = (props) => {
  const {
    introSection,
    data,
    type,
  } = props;

  const { type: sectionType } = getDocumentFields(data, ['type']);

  switch (sectionType) {
  case SECTION_TYPES.intro:
    return (
      <Intro
        introSection={introSection}
        type={type}
        data={data?.fields}
      />
    );
  case SECTION_TYPES.personIntro:
    return (
      <NewPersonIntro
        introSection={introSection}
        type={type}
        data={data?.fields}
      />
    );

  case SECTION_TYPES.plainTextSection:
    return (
      <PlainTextSection
        {...props}
        section={data}
      />
    );

  case SECTION_TYPES.youtubeVideos:
    return (
      <YoutubeVideosSection
        {...props}
        section={data}
      />
    );
  case SECTION_TYPES.caseProcess:
    return (
      <CaseProcess
        data={data?.fields}
        type={type}
      />
    );
  case SECTION_TYPES.tabs:
    return (
      <TabsSection
        section={data}
        type={type}
      />
    );
  case SECTION_TYPES.review:
    return (
      <ReviewsSection
        section={data}
        type={type}
      />
    );
  case SECTION_TYPES.parallax:
    return (
      <CaseParallax
        data={data?.fields}
        type={type}
      />
    );
  case SECTION_TYPES.images:
    return (
      <Images
        data={data?.fields}
        type={type}
      />
    );
  case SECTION_TYPES.photos:
    return (
      <PhotoGallery
        sectionData={data}
        type={type}
      />
    );
  case SECTION_TYPES.appDevelopmentSvgList:
    return <SvgListSection {...props} />;
  case SECTION_TYPES.appDevelopmentProcess:
    return <ProcessSection {...props} />;
  case SECTION_TYPES.appDevelopmentCards:
    return <CardsSection {...props} />;

  case SECTION_TYPES.svgList:
    return (
      <SvgList
        section={data}
        type={type}
      />
    );

  case SECTION_TYPES.cardsSlider:
    return (
      <CardsSlider
        section={data}
        type={type}
      />
    );

  case SECTION_TYPES.portfolio:
    return (
      <Works
        section={data}
        type={type}
      />
    );

  case SECTION_TYPES.card:
    return (
      <Card
        data={data}
        type={type}
      />
    );

  case SECTION_TYPES.cards:
    return (
      <CardsSection
        data={data}
        type={type}
        sectionType="cards"
      />
    );
  case SECTION_TYPES.cta:
    return (
      <CaseProcess
        data={data.fields}
        type={type}
        rightSide={<ContactForm />}
      />
    );
  case SECTION_TYPES.blog:
    return (
      <Blog
        sectionData={data}
        {...props}
      />
    );
  case SECTION_TYPES.pageIntro:
    return (
      <PageIntroSection
        introSection={introSection}
        section={data}
        {...props}
      />
    );
  case SECTION_TYPES.faq:
    return (
      <FaqSection
        section={data}
        {...props}
      />
    );
  case SECTION_TYPES.assessmentSection:
    return (
      <AssessmentSection
        section={data}
        {...props}
      />
    );
  default:
    return null;
  }
};

SectionSelector.propTypes = {
  introSection: PropTypes.shape({}),
  data: PropTypes.shape({
    fields: PropTypes.shape({}),
  }),
  type: PropTypes.string,
};

export default SectionSelector;
